// app/context/SessionContext.tsx
"use client";

import { createContext, useContext } from "react";

type NewType = any;

const SessionContext = createContext<NewType>(null);

export const useSession = () => {
    const session = useContext(SessionContext);
    if (!session) throw new Error("useSession must be used within a <SessionProvider>");
    return session;
};

export default SessionContext;
